import React from "react";
import { Link } from 'react-router-dom';
import person from '../imgs/person.png';
import earthGrid from '../imgs/earth-grid.png';


export default function Navbar() {

 return (
  <nav className="Navbar">
   <ul className="Navbar-list">
    <li className="Navbar-item">
     <Link to="/rick-and-morty"><img src={person} className="Navbar-img" alt="person" /></Link>
    </li>
    <li className="Navbar-item">
     <Link to="/rick-and-morty/Location"><img src={earthGrid} className="Navbar-img" alt="earthGrid" /></Link>
    </li>
   </ul>
  </nav>
 )
}